<template>
  <div style="height: 100%">
    <!-- 页面骨架:筛选区(订单号/手机号/供货商/状态/退款状态/下单时间段) + 列表 + 详情/发货修改弹窗 -->
    <div style="display: flex; width: 100%">
      <div style="width: 100%">
        <el-row class="filter-bar" ref="filterBar">
          <el-input v-model="formDatas.orderNo" style="width: 180px" size="mini" placeholder="订单号"
            clearable></el-input>
          <el-input v-model="formDatas.phone" style="width: 140px;" size="mini"
            placeholder="下单手机号" clearable></el-input>
          <el-select size="mini" v-model="formDatas.amsId" filterable clearable placeholder="供货商"
            style="width: 150px;" @change="partserch">
            <el-option v-for="item in supplierList" :key="item.amsId"
              :label="item.amsName + (item.amsStatus === 2 ? '(已禁用)' : '')" :value="item.amsId"></el-option>
          </el-select>
          <el-select size="mini" v-model="formDatas.amoStatus" clearable placeholder="订单状态"
            style="width: 130px;" @change="partserch">
            <el-option label="已支付待发货" :value="1" key="o1"></el-option>
            <el-option label="已发货" :value="2" key="o2"></el-option>
            <el-option label="已完成" :value="3" key="o3"></el-option>
            <el-option label="已退款" :value="5" key="o5"></el-option>
          </el-select>
          <el-select size="mini" v-model="formDatas.refundStatus" clearable placeholder="退款状态"
            style="width: 120px;" @change="partserch">
            <el-option label="无" :value="0" key="r0"></el-option>
            <el-option label="申请中" :value="1" key="r1"></el-option>
            <el-option label="已退款" :value="2" key="r2"></el-option>
            <el-option label="已驳回" :value="3" key="r3"></el-option>
          </el-select>
          <el-date-picker v-model="payTimeStart" type="date" value-format="yyyy-MM-dd" placeholder="下单时间-开始"
            style="width: 145px;" size="mini" clearable></el-date-picker>
          <el-date-picker v-model="payTimeEnd" type="date" value-format="yyyy-MM-dd" placeholder="下单时间-结束"
            style="width: 145px;" size="mini" clearable></el-date-picker>
          <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
            style="">搜索</el-button>
          <el-button type="warning" size="mini" icon="el-icon-download" :loading="exportLoading"
            @click="exportExcel">导出Excel</el-button>
          </div>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            row-key-field-name="amoId" style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
    </div>

    <!-- 订单详情弹窗:订单信息 + 关联订单记录摘要(record可能为空) -->
    <el-dialog title="商城订单详情" :visible.sync="detailDialog" width="820px">
      <div v-if="detailData">
        <el-descriptions title="订单信息" :column="2" border size="small">
          <el-descriptions-item label="订单号">{{ detailData.order.amoOrderNo || "-" }}</el-descriptions-item>
          <el-descriptions-item label="下单手机号">{{ detailData.order.amoPhone || "-" }}</el-descriptions-item>
          <el-descriptions-item label="商品名称">{{ detailData.order.amgName || "-" }}</el-descriptions-item>
          <el-descriptions-item label="数量">{{ detailData.order.amoNum }}</el-descriptions-item>
          <el-descriptions-item label="实付金额">
            {{ detailData.order.amoPriceStr != null && detailData.order.amoPriceStr !== ""
              ? detailData.order.amoPriceStr + "元"
              : detailData.order.amoPrice != null ? fenToYuan(detailData.order.amoPrice) + "元" : "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="下单时间">{{ detailData.order.amoPayTime || "-" }}</el-descriptions-item>
          <el-descriptions-item label="订单状态">
            <el-tag :type="orderTagType(detailData.order.amoStatus)" size="small">
              {{ detailData.order.amoStatusDes || orderStatusText(detailData.order.amoStatus) }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="退款状态">
            <el-tag v-if="detailData.order.amoRefundStatus" :type="refundTagType(detailData.order.amoRefundStatus)"
              size="small">{{ detailData.order.amoRefundStatusDes || refundStatusText(detailData.order.amoRefundStatus) }}</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="退款原因" :span="2">
            {{ detailData.order.amoRefundReason || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="物流公司">{{ detailData.order.amoExpressCompanyName || "-" }}</el-descriptions-item>
          <el-descriptions-item label="运单号">{{ detailData.order.amoExpressNo || "-" }}</el-descriptions-item>
        </el-descriptions>

        <!-- 收货信息模块:独立分区,仅待发货且不在退款流程时可修改(后端同口径校验) -->
        <el-descriptions :column="2" border size="small" style="margin-top: 16px">
          <template slot="title">
            <div class="detail-section-title">
              <span>收货信息</span>
              <!-- 图标圆钮:视觉最轻,文案由 tooltip 承载 -->
              <el-tooltip content="修改收货信息(仅待发货且不在退款流程可改)" placement="top">
                <el-button v-if="canEditAddress" type="text" size="mini" icon="el-icon-edit"
                  class="section-edit-btn" @click="openAddress"></el-button>
              </el-tooltip>
            </div>
          </template>
          <el-descriptions-item label="收货人">{{ detailData.order.amaReceiver || "-" }}</el-descriptions-item>
          <el-descriptions-item label="收货电话">{{ detailData.order.amaPhone || "-" }}</el-descriptions-item>
          <el-descriptions-item label="省市区">{{ detailData.order.amaRegion || "-" }}</el-descriptions-item>
          <el-descriptions-item label="详细地址">{{ detailData.order.amaDetail || "-" }}</el-descriptions-item>
        </el-descriptions>

        <!-- 关联订单记录摘要:退款审核时看钱路(匹配/分账状态) -->
        <el-descriptions v-if="detailData.record" title="关联订单记录(分账钱路)" :column="2" border size="small"
          style="margin-top: 16px">
          <el-descriptions-item label="记录id">{{ detailData.record.asorId }}</el-descriptions-item>
          <el-descriptions-item label="录入手机号">{{ detailData.record.asorPhone || "-" }}</el-descriptions-item>
          <el-descriptions-item label="匹配状态">
            <el-tag :type="recordMatchTagType(detailData.record.asorStatus)" size="small">
              {{ detailData.record.asorStatusDes || recordMatchText(detailData.record.asorStatus) }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="分账状态">
            <el-tag :type="recordBillTagType(detailData.record.asorBillStatus)" size="small">
              {{ detailData.record.asorBillStatusDes || recordBillText(detailData.record.asorBillStatus) }}</el-tag>
          </el-descriptions-item>
        </el-descriptions>
        <el-alert v-else title="无关联订单记录(未扫码建记录:仅权益金扣减,无分账链路)" type="info" :closable="false"
          show-icon style="margin-top: 16px"></el-alert>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialog = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 发货信息修改弹窗:快递公司只能下拉选,运单号>=8位;待发货录入后即转已发货 -->
    <el-dialog :title="expressRow && expressRow.amoStatus === 1 ? '订单发货' : '修改物流信息'"
      :visible.sync="expressDialog" width="480px" :close-on-click-modal="false" @closed="handleExpressClosed">
      <div v-if="expressRow" style="margin-bottom: 12px; color: #606266; font-size: 13px">
        <span style="margin-right: 16px">订单号：{{ expressRow.amoOrderNo }}</span>
        <span>收货人：{{ expressRow.amaReceiver || "-" }}</span>
      </div>
      <el-alert v-if="expressRow && expressRow.amoStatus === 1" title="待发货订单录入运单号后将转为已发货状态"
        type="warning" :closable="false" show-icon style="margin-bottom: 16px"></el-alert>
      <el-form ref="expressFormRef" :model="expressForm" label-width="90px" :rules="expressRules">
        <el-form-item label="快递公司" prop="expressCompany">
          <el-select v-model="expressForm.expressCompany" filterable placeholder="请选择快递公司" style="width: 100%">
            <el-option v-for="item in expressCompanies" :key="item.code" :label="item.name"
              :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运单号" prop="expressNo">
          <el-input v-model.trim="expressForm.expressNo" maxlength="50" placeholder="请输入运单号(至少8位)"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="expressDialog = false">取 消</el-button>
        <el-button type="primary" :loading="expressSubmitLoading" @click="sureExpress">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改收货信息弹窗:校验与后端checkAddressForm同口径(收货人≤50/电话11位/省市区与详细地址必填≤300) -->
    <el-dialog title="修改收货信息" :visible.sync="addressDialog" width="480px" :close-on-click-modal="false"
      @closed="handleAddressClosed">
      <div v-if="addressRow" style="margin-bottom: 12px; color: #606266; font-size: 13px">
        订单号：{{ addressRow.amoOrderNo }}
      </div>
      <el-form ref="addressFormRef" :model="addressForm" label-width="90px" :rules="addressRules">
        <el-form-item label="收货人" prop="amaReceiver">
          <el-input v-model.trim="addressForm.amaReceiver" maxlength="50" placeholder="请输入收货人"></el-input>
        </el-form-item>
        <el-form-item label="收货电话" prop="amaPhone">
          <el-input v-model.trim="addressForm.amaPhone" maxlength="11" placeholder="请输入11位收货电话"></el-input>
        </el-form-item>
        <el-form-item label="省市区" prop="amaRegion">
          <!-- 与小程序端同源三级联动(getSysRegionList 逐级加载),提交按「省 市 区」空格拼接同款格式 -->
          <div class="region-selects">
            <el-select v-model="selectedProvince" filterable placeholder="省" :loading="regionLoading"
              @change="handleProvinceChange">
              <el-option v-for="item in regionProvinceList" :key="item.srCode" :label="item.srName"
                :value="item.srCode"></el-option>
            </el-select>
            <el-select v-model="selectedCity" filterable placeholder="市" :disabled="!selectedProvince"
              @change="handleCityChange">
              <el-option v-for="item in regionCityList" :key="item.srCode" :label="item.srName"
                :value="item.srCode"></el-option>
            </el-select>
            <el-select v-model="selectedDistrict" filterable placeholder="区/县" :disabled="!selectedCity"
              @change="handleDistrictChange">
              <el-option v-for="item in regionDistrictList" :key="item.srCode" :label="item.srName"
                :value="item.srCode"></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="详细地址" prop="amaDetail">
          <el-input v-model.trim="addressForm.amaDetail" maxlength="300" type="textarea" :rows="2"
            placeholder="请输入详细地址"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addressDialog = false">取 消</el-button>
        <el-button type="primary" :loading="addressSubmitLoading" @click="sureAddress">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 物流轨迹弹窗:快递公司+运单号+el-timeline轨迹(track.data最新在前,与小程序用户端同口径) -->
    <el-dialog title="物流轨迹" :visible.sync="trackDialog" width="560px">
      <div v-loading="trackLoading" element-loading-text="物流查询中...">
        <div v-if="trackInfo" style="margin-bottom: 16px; color: #606266; font-size: 13px">
          <span style="margin-right: 24px">物流公司：{{ trackInfo.expressCompanyName || trackInfo.expressCompany || "-" }}</span>
          <span>运单号：{{ trackInfo.expressNo || "-" }}</span>
        </div>
        <el-timeline v-if="trackNodes.length" style="padding-left: 5px">
          <!-- 首节点即最新轨迹,高亮提示当前位置 -->
          <el-timeline-item v-for="(node, index) in trackNodes" :key="node.key"
            :type="index === 0 ? 'primary' : ''" :timestamp="node.time || ''">
            {{ node.context }}
          </el-timeline-item>
        </el-timeline>
        <!-- 空态:有运单号但轨迹为空(如刚发货未揽收)或缓存无数据 -->
        <div v-else-if="!trackLoading" class="empty-data">暂无轨迹</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="trackDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import {
  getAjefMallSupplierList,
  getAjefMallOrderList,
  getAjefMallOrderDetails,
  updateAjefMallOrderRefundAdopt,
  updateAjefMallOrderRefundReject,
  updateAjefMallOrderExpress,
  getAjefMallOrderExpress,
  updateAjefMallOrderAddressAdmin,
  getSysRegionList,
  exportAjefMallOrderExcel,
} from "../../api/api";

// 快递公司下拉(13家,编码取快递100口径,与后端KuaiDiUtils支持列表一致,不允许手填)
const EXPRESS_COMPANIES = [
  { code: "zhongtong", name: "中通快递" },
  { code: "yuantong", name: "圆通速递" },
  { code: "yunda", name: "韵达快递" },
  { code: "shentong", name: "申通快递" },
  { code: "huitongkuaidi", name: "百世快递" },
  { code: "jtexpress", name: "极兔速递" },
  { code: "shunfeng", name: "顺丰速运" },
  { code: "jd", name: "京东物流" },
  { code: "debangkuaidi", name: "德邦快递" },
  { code: "ems", name: "EMS" },
  { code: "zhaijisong", name: "宅急送" },
  { code: "shansong", name: "闪送" },
  { code: "kfw", name: "快服务" },
];

export default {
  name: "MallOrder",
  components: {},
  data() {
    return {
      tableLoading: false,
      exportLoading: false,
      totalCount: 0,
      tableHight: 520,
      tableData: [],
      formDatas: {
        orderNo: "",
        phone: "",
        amsId: "",
        amoStatus: "",
        refundStatus: "",
        payTimeStart: "",
        payTimeEnd: "",
        currentPage: 1,
        pageSize: 10,
      },
      // 下单时间筛选(单独存放,提交时拼接时分秒)
      payTimeStart: "",
      payTimeEnd: "",
      // 供货商下拉数据(大页拉全量,禁用供货商历史订单也可筛)
      supplierList: [],
      // 详情弹窗
      detailDialog: false,
      detailData: null,
      // 发货信息修改弹窗
      expressDialog: false,
      expressSubmitLoading: false,
      expressRow: null,
      expressForm: {
        amoId: null,
        expressCompany: "",
        expressNo: "",
      },
      expressRules: {
        expressCompany: [{ required: true, message: "请选择快递公司", trigger: "change" }],
        expressNo: [
          { required: true, message: "请输入运单号", trigger: "blur" },
          // 与后端校验口径一致:去空格后至少8位
          { validator: (rule, value, callback) => (value && value.trim().length >= 8) ? callback() : callback(new Error("运单号至少8位")), trigger: "blur" },
        ],
      },
      expressCompanies: EXPRESS_COMPANIES,
      // 修改收货信息弹窗(仅待发货且不在退款流程:详情收货信息模块入口,校验同后端)
      addressDialog: false,
      addressSubmitLoading: false,
      addressRow: null,
      addressForm: {
        amoId: null,
        amaReceiver: "",
        amaPhone: "",
        amaRegion: "",
        amaDetail: "",
      },
      addressRules: {
        amaReceiver: [
          { required: true, message: "请输入收货人", trigger: "blur" },
          { max: 50, message: "收货人不能超过50字", trigger: "blur" },
        ],
        amaPhone: [
          { required: true, message: "请输入收货电话", trigger: "blur" },
          { pattern: /^\d{11}$/, message: "收货电话为11位数字", trigger: "blur" },
        ],
        amaRegion: [
          { required: true, message: "请选择省市区", trigger: "change" },
        ],
        amaDetail: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
          { max: 300, message: "详细地址不能超过300字", trigger: "blur" },
        ],
      },
      // 省市区三级联动(getSysRegionList 逐级加载,与小程序地址编辑同源同格式「省 市 区」空格拼接):
      // 未动选择器时提交保留原值;动过任一级则必须三级选全才可通过必填校验
      regionProvinceList: [],
      regionCityList: [],
      regionDistrictList: [],
      selectedProvince: "",
      selectedCity: "",
      selectedDistrict: "",
      regionLoading: false,
      regionChildrenCache: {}, // srSuperiorCode -> 子级列表(页面级缓存,避免反复请求)
      // 物流轨迹弹窗(trackInfo为后端返回的{expressCompany...expressNo,track},trackNodes为解析后节点)
      trackDialog: false,
      trackLoading: false,
      trackInfo: null,
      trackNodes: [],
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          fixed: "left",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "amoOrderNo",
          key: "amoOrderNo",
          title: "订单号",
          width: 210,
          fixed: "left",
          align: "center",
          renderBodyCell: ({ row }) => row.amoOrderNo || "-",
        },
        {
          field: "amgName",
          key: "amgName",
          title: "商品",
          width: 160,
          align: "center",
          renderBodyCell: ({ row }) => row.amgName || "-",
        },
        {
          field: "amsName",
          key: "amsName",
          title: "供货商",
          width: 140,
          align: "center",
          renderBodyCell: ({ row }) => row.amsName || "-",
        },
        {
          field: "amoPhone",
          key: "amoPhone",
          title: "手机号",
          width: 120,
          align: "center",
        },
        {
          field: "amoPrice",
          key: "amoPrice",
          title: "金额",
          width: 90,
          align: "center",
          renderBodyCell: ({ row }) => {
            // 优先用后端格式化字段,兜底本地分转元(整数除法避免浮点误差)
            if (row.amoPriceStr != null && row.amoPriceStr !== "") {
              return row.amoPriceStr + "元";
            }
            return row.amoPrice != null ? this.fenToYuan(row.amoPrice) + "元" : "-";
          },
        },
        // 分账信息(2026-10-13,财务对账):按订单号关联商户订单记录;商户未录入匹配时金额为空只显示状态
        {
          field: "asorAmountBillYuan",
          key: "asorAmountBillYuan",
          title: "参与分账金额",
          width: 110,
          align: "center",
          renderBodyCell: ({ row }) => {
            return row.asorAmountBillYuan != null && row.asorAmountBillYuan !== ""
              ? row.asorAmountBillYuan + "元"
              : "-";
          },
        },
        {
          field: "asorExchangeShopYuan",
          key: "asorExchangeShopYuan",
          title: "商铺分账金额",
          width: 110,
          align: "center",
          renderBodyCell: ({ row }) => {
            return row.asorExchangeShopYuan != null && row.asorExchangeShopYuan !== ""
              ? row.asorExchangeShopYuan + "元"
              : "-";
          },
        },
        {
          field: "asorBillStatusDes",
          key: "asorBillStatusDes",
          title: "分账状态",
          width: 90,
          align: "center",
          renderBodyCell: ({ row }) => {
            return row.asorBillStatusDes != null && row.asorBillStatusDes !== ""
              ? row.asorBillStatusDes
              : "-";
          },
        },
        // 分账时间(2026-10-13,财务对账):首次分账成功时间,退款不覆盖
        {
          field: "asorBillTime",
          key: "asorBillTime",
          title: "分账时间",
          width: 160,
          align: "center",
          renderBodyCell: ({ row }) =>
            row.asorBillTime != null && row.asorBillTime !== "" ? row.asorBillTime : "-",
        },
        {
          field: "amoStatus",
          key: "amoStatus",
          title: "订单状态",
          width: 110,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            // 1已支付待发货warning 2已发货primary 3已完成success 5已退款info
            return h("el-tag", { props: { type: this.orderTagType(row.amoStatus), size: "mini" } },
              row.amoStatusDes || this.orderStatusText(row.amoStatus));
          },
        },
        {
          field: "amoRefundStatus",
          key: "amoRefundStatus",
          title: "退款状态",
          width: 100,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            if (!row.amoRefundStatus) {
              return "-";
            }
            return h("el-tag", { props: { type: this.refundTagType(row.amoRefundStatus), size: "mini" } },
              row.amoRefundStatusDes || this.refundStatusText(row.amoRefundStatus));
          },
        },
        {
          field: "amaReceiver",
          key: "amaReceiver",
          title: "收货人",
          width: 90,
          align: "center",
          renderBodyCell: ({ row }) => row.amaReceiver || "-",
        },
        { field: "amoPayTime", key: "amoPayTime", title: "下单时间", width: 170, align: "center" },
        {
          field: "operation",
          key: "operation",
          title: "操作",
          width: 230,
          align: "center",
          fixed: "right",
          renderBodyCell: ({ row }, h) => {
            const buttons = [
              h("el-button", {
                props: { type: "text", size: "mini" },
                style: { color: "#409EFF", padding: "0", marginRight: "10px" },
                on: { click: () => this.openDetail(row) },
              }, "详情"),
            ];
            // 发货按钮:待发货显眼「发货」,已发货显示「改物流」
            if (row.amoStatus === 1 || row.amoStatus === 2) {
              buttons.push(h("el-button", {
                props: { type: "text", size: "mini" },
                style: { color: "#67C23A", padding: "0", marginRight: "10px" },
                on: { click: () => this.openExpress(row) },
              }, row.amoStatus === 1 ? "发货" : "改物流"));
            }
            // 查物流:已发货/已完成订单查轨迹(紧跟改物流,同类操作相邻)
            if (row.amoStatus === 2 || row.amoStatus === 3) {
              buttons.push(h("el-button", {
                props: { type: "text", size: "mini" },
                style: { color: "#E6A23C", padding: "0", marginRight: "10px" },
                on: { click: () => this.openTrack(row) },
              }, "查物流"));
            }
            // 退款审核:仅退款申请中(refundStatus=1)显示 通过/驳回
            if (row.amoRefundStatus === 1) {
              buttons.push(h("el-button", {
                props: { type: "text", size: "mini" },
                style: { color: "#67C23A", padding: "0", marginRight: "10px" },
                on: { click: () => this.handleRefundAdopt(row) },
              }, "通过"));
              buttons.push(h("el-button", {
                props: { type: "text", size: "mini" },
                style: { color: "#F56C6C", padding: "0" },
                on: { click: () => this.handleRefundReject(row) },
              }, "驳回"));
            }
            return h("div", buttons);
          },
        },
      ],
    };
  },
  computed: {
    // 收货信息可改判定(与后端校验同口径):仅待发货(1)且不在退款流程(refund_status 无/0)
    canEditAddress() {
      const order = this.detailData && this.detailData.order;
      return !!order && order.amoStatus === 1 && !order.amoRefundStatus;
    },
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = calcTableHeight(this, this.windheight, 140);
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = calcTableHeight(this, val, 140);
        }
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
  },
  created() {
    this.windheight = this.$store.state.windheight;
    this.tableHight = calcTableHeight(this, this.windheight, 140);
    this.getList();
    this.getSupplierList();
  },
  methods: {
    // 订单状态文案/胶囊颜色(1已支付待发货 2已发货 3已完成 5已退款)
    orderStatusText(status) {
      const map = { 1: "已支付待发货", 2: "已发货", 3: "已完成", 5: "已退款" };
      return map[status] || "-";
    },
    orderTagType(status) {
      const map = { 1: "warning", 2: "", 3: "success", 5: "info" };
      return map[status] || "info";
    },
    // 退款状态文案/胶囊颜色(1申请中 2已退款 3已驳回)
    refundStatusText(status) {
      const map = { 1: "申请中", 2: "已退款", 3: "已驳回" };
      return map[status] || "-";
    },
    refundTagType(status) {
      const map = { 1: "warning", 2: "success", 3: "danger" };
      return map[status] || "info";
    },
    // 关联记录匹配状态(1待匹配 2已匹配 3无匹配)
    recordMatchText(status) {
      const map = { 1: "待匹配", 2: "已匹配", 3: "无匹配" };
      return map[status] || "-";
    },
    recordMatchTagType(status) {
      const map = { 1: "warning", 2: "success", 3: "info" };
      return map[status] || "info";
    },
    // 关联记录分账状态(1待分账 2已分账 3已退款)
    recordBillText(status) {
      const map = { 1: "待分账", 2: "已分账", 3: "已退款" };
      return map[status] || "-";
    },
    recordBillTagType(status) {
      const map = { 1: "warning", 2: "success", 3: "danger" };
      return map[status] || "info";
    },
    // 分转元展示:整数除法+取余,避免浮点误差
    fenToYuan(fen) {
      const yuan = Math.floor(fen / 100);
      const cent = Math.abs(fen % 100);
      return yuan + "." + String(cent).padStart(2, "0");
    },
    // 供货商下拉数据(大页拉全量)
    getSupplierList() {
      getAjefMallSupplierList({ currentPage: 1, pageSize: 9999 }).then((res) => {
        if (!res) {
          return;
        }
        this.supplierList = res.data || [];
      });
    },
    getList() {
      // 修复OBS-01：每次列表请求前统一同步时间筛选，避免清空日期后翻页/改页大小仍携带旧日期参数
      this.fillPayTime();
      this.tableLoading = true;
      getAjefMallOrderList(this.formDatas).then((res) => {
        this.tableLoading = false;
        // 失败时拦截器已弹提示并返回undefined
        if (!res) {
          return;
        }
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    // 拼接时间范围:开始补00:00:00,结束补23:59:59
    fillPayTime() {
      this.formDatas.payTimeStart = this.payTimeStart ? this.payTimeStart + " 00:00:00" : "";
      this.formDatas.payTimeEnd = this.payTimeEnd ? this.payTimeEnd + " 23:59:59" : "";
    },
    partserch() {
      // 时间筛选同步已统一收口到 getList() 开头（修复OBS-01）
      this.formDatas.currentPage = 1;
      this.getList();
    },
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.getList();
    },
    // 详情弹窗:返回{order,record}
    openDetail(row) {
      getAjefMallOrderDetails({ amoId: row.amoId }).then((res) => {
        if (!res) {
          return;
        }
        this.detailData = res.data;
        this.detailDialog = true;
      });
    },
    // 退款审核-通过:二次确认钱务影响后调用
    handleRefundAdopt(row) {
      this.$confirm(
        "确认通过该退款申请？通过后将回退用户权益金、若已分账将同步回退分账金额、并回补商品库存。",
        "退款审核-通过",
        { type: "warning", confirmButtonText: "确认通过", cancelButtonText: "取消" }
      ).then(() => {
        updateAjefMallOrderRefundAdopt({ amoId: row.amoId }).then((res) => {
          if (!res) {
            return;
          }
          this.$message.success(res.data || "退款完成");
          this.getList();
        });
      }).catch(() => { });
    },
    // 退款审核-驳回:必填驳回原因,用户可修改原因再次申请
    handleRefundReject(row) {
      this.$prompt("请输入驳回原因(必填),驳回后用户可修改原因再次申请退款", "退款审核-驳回", {
        confirmButtonText: "确定驳回",
        cancelButtonText: "取消",
        inputType: "textarea",
        inputValidator: (v) => !!(v && v.trim()) || "驳回原因不能为空",
      }).then(({ value }) => {
        updateAjefMallOrderRefundReject({ amoId: row.amoId, rejectReason: value.trim() }).then((res) => {
          if (!res) {
            return;
          }
          this.$message.success("已驳回");
          this.getList();
        });
      }).catch(() => { });
    },
    // 打开发货信息修改弹窗(待发货=发货,已发货=改单号纠错)
    openExpress(row) {
      this.expressRow = row;
      this.expressDialog = true;
      this.$nextTick(() => {
        this.expressForm = {
          amoId: row.amoId,
          // 回显已有快递公司编码(不在13家列表时置空重选)
          expressCompany: EXPRESS_COMPANIES.some((item) => item.code === row.amoExpressCompany)
            ? row.amoExpressCompany
            : "",
          expressNo: row.amoExpressNo || "",
        };
      });
    },
    handleExpressClosed() {
      this.$refs.expressFormRef.resetFields();
      this.expressForm = { amoId: null, expressCompany: "", expressNo: "" };
    },
    // 提交发货信息:后端校验编码强校验+待发货转已发货
    sureExpress() {
      this.$refs.expressFormRef.validate((valid) => {
        if (!valid) {
          return;
        }
        this.expressSubmitLoading = true;
        updateAjefMallOrderExpress(this.expressForm).then((res) => {
          this.expressSubmitLoading = false;
          if (!res) {
            return;
          }
          this.$message.success("修改成功");
          this.expressDialog = false;
          this.getList();
        }).catch(() => {
          this.expressSubmitLoading = false;
        });
      });
    },
    // 打开修改收货信息弹窗:回显详情当前收货快照;省市区按当前值名称反查回填三级下拉
    openAddress() {
      const order = this.detailData && this.detailData.order;
      if (!order) {
        return;
      }
      this.addressRow = order;
      this.addressDialog = true;
      // 省市区选择态复位后回显当前值
      this.selectedProvince = "";
      this.selectedCity = "";
      this.selectedDistrict = "";
      this.regionCityList = [];
      this.regionDistrictList = [];
      if (!this.regionProvinceList.length) {
        this.loadRegionChildren("", (list) => {
          this.regionProvinceList = list;
          this.echoRegion(order.amaRegion);
        });
      } else {
        this.echoRegion(order.amaRegion);
      }
      this.$nextTick(() => {
        this.addressForm = {
          amoId: order.amoId,
          amaReceiver: order.amaReceiver || "",
          amaPhone: order.amaPhone || "",
          amaRegion: order.amaRegion || "",
          amaDetail: order.amaDetail || "",
        };
      });
    },
    // 省市区回显:按「省 市 区」名称链式反查 code 逐级回填下拉(只设选中值不走 change,
    // 不动 addressForm.amaRegion);任一级名称匹配不到(如历史数据格式不符)即停止后续回显,
    // 下拉保持未选中态由用户重选(未动选择器提交仍沿用原值)
    echoRegion(amaRegion) {
      const parts = (amaRegion || "").trim().split(/\s+/);
      if (parts.length < 3) {
        return;
      }
      const [provinceName, cityName, districtName] = parts;
      const findCode = (list, name) => {
        const hit = list.find((i) => i.srName === name);
        return hit ? hit.srCode : "";
      };
      const provinceCode = findCode(this.regionProvinceList, provinceName);
      if (!provinceCode) {
        return;
      }
      this.selectedProvince = provinceCode;
      this.loadRegionChildren(provinceCode, (cityList) => {
        this.regionCityList = cityList;
        const cityCode = findCode(cityList, cityName);
        if (!cityCode) {
          return;
        }
        this.selectedCity = cityCode;
        this.loadRegionChildren(cityCode, (districtList) => {
          this.regionDistrictList = districtList;
          this.selectedDistrict = findCode(districtList, districtName);
        });
      });
    },
    handleAddressClosed() {
      this.$refs.addressFormRef.resetFields();
      this.addressForm = { amoId: null, amaReceiver: "", amaPhone: "", amaRegion: "", amaDetail: "" };
      this.selectedProvince = "";
      this.selectedCity = "";
      this.selectedDistrict = "";
      this.regionCityList = [];
      this.regionDistrictList = [];
    },
    // 拉某级地区列表(superiorCode 空=省级);结果回传 via callback,页面级缓存防重复请求
    loadRegionChildren(superiorCode, callback) {
      const cache = this.regionChildrenCache;
      if (cache[superiorCode]) {
        callback(cache[superiorCode]);
        return;
      }
      this.regionLoading = true;
      const params = superiorCode ? { srSuperiorCode: superiorCode } : {};
      getSysRegionList(params).then((res) => {
        this.regionLoading = false;
        const list = (res && res.data) || [];
        cache[superiorCode] = list;
        callback(list);
      }).catch(() => {
        this.regionLoading = false;
        callback([]);
      });
    },
    // 三级选中变更统一收口:选满三级按「省 市 区」空格拼接写入表单(与小程序 finishRegion 同格式),
    // 未凑齐则置空,由 amaRegion 必填校验拦截提交(未动选择器时不触发本方法,提交沿用订单原值)
    syncRegionField() {
      const p = this.regionProvinceList.find((i) => i.srCode === this.selectedProvince);
      const c = this.regionCityList.find((i) => i.srCode === this.selectedCity);
      const d = this.regionDistrictList.find((i) => i.srCode === this.selectedDistrict);
      this.addressForm.amaRegion = p && c && d ? [p.srName, c.srName, d.srName].join(" ") : "";
    },
    handleProvinceChange(code) {
      this.selectedCity = "";
      this.selectedDistrict = "";
      this.regionCityList = [];
      this.regionDistrictList = [];
      if (code) {
        this.loadRegionChildren(code, (list) => { this.regionCityList = list; });
      }
      this.syncRegionField();
    },
    handleCityChange(code) {
      this.selectedDistrict = "";
      this.regionDistrictList = [];
      if (code) {
        this.loadRegionChildren(code, (list) => { this.regionDistrictList = list; });
      }
      this.syncRegionField();
    },
    handleDistrictChange() {
      this.syncRegionField();
    },
    // 提交修改收货信息:成功后刷新详情弹窗(收货信息模块即时更新)与列表
    sureAddress() {
      this.$refs.addressFormRef.validate((valid) => {
        if (!valid) {
          return;
        }
        this.addressSubmitLoading = true;
        updateAjefMallOrderAddressAdmin(this.addressForm).then((res) => {
          this.addressSubmitLoading = false;
          if (!res) {
            return;
          }
          this.$message.success(res.data || "修改成功");
          this.addressDialog = false;
          // 详情弹窗保持打开并回读最新快照(amoId 未变)
          if (this.detailData && this.detailDialog) {
            this.openDetail(this.detailData.order);
          }
          this.getList();
        }).catch(() => {
          this.addressSubmitLoading = false;
        });
      });
    },
    // 解析快递100轨迹(与小程序端orderDetails.parseTrack同口径,两端展示保持一致):
    // track为{state,data:[{time,ftime,context}]}结构,data最新节点在前,保持原始顺序不重排;
    // 逐条判空兜底,异常/为空返回空数组由模板走"暂无轨迹"空态
    parseTrack(trackSource) {
      if (!trackSource) {
        return [];
      }
      try {
        const track = typeof trackSource === "string" ? JSON.parse(trackSource) : trackSource;
        const rawNodes = track && Array.isArray(track.data) ? track.data : [];
        return rawNodes
          .filter((node) => node && (node.context || node.desc))
          .map((node, idx) => ({
            key: "node-" + idx, // 稳定唯一key(相邻节点time可能重复,不可作key)
            time: node.time || node.ftime || "",
            context: node.context || node.desc || "",
          }));
      } catch (e) {
        return [];
      }
    },
    // 查物流:打开弹窗即查(后端缓存30分钟优先,超30天只读缓存)
    openTrack(row) {
      this.trackInfo = null;
      this.trackNodes = [];
      this.trackDialog = true;
      this.trackLoading = true;
      getAjefMallOrderExpress({ amoId: row.amoId }).then((res) => {
        this.trackLoading = false;
        // 业务失败(未发货/超查询期限/查询失败等):拦截器已用Notification原样弹出后端msg,这里关弹窗不留空壳
        if (!res) {
          this.trackDialog = false;
          return;
        }
        const data = res.data || {};
        this.trackInfo = data;
        this.trackNodes = this.parseTrack(data.track);
      }).catch(() => {
        // 网络异常:拦截器已弹"后台错误",关弹窗复位
        this.trackLoading = false;
        this.trackDialog = false;
      });
    },
    // 导出excel(与列表同筛选;文件流走裸axios,需前端转blob下载)
    exportExcel() {
      this.fillPayTime();
      this.exportLoading = true;
      exportAjefMallOrderExcel(this.formDatas).then((res) => {
        this.exportLoading = false;
        if (!res || !res.data) {
          this.$message.error("导出失败");
          return;
        }
        const buf = res.data;
        // 修复OBS-02：responseType=arraybuffer 时后端业务错误返回的 JSON 也会进 then，
        // 以 xlsx 魔数（PK=0x50 0x4B，zip 头）判别：非 PK 按文本解析取 msg 提示，不再下载坏文件
        const head = new Uint8Array(buf.slice(0, 2));
        if (!(head[0] === 0x50 && head[1] === 0x4B)) {
          let msg = "导出失败";
          try {
            const json = JSON.parse(new TextDecoder("utf-8").decode(buf));
            if (json && json.msg) {
              msg = json.msg;
            }
          } catch (e) {
            // 响应体非 JSON（如网关 HTML 错误页）时保持默认提示
          }
          this.$message.error(msg);
          return;
        }
        const blob = new Blob([buf], { type: "application/vnd.ms-excel" });
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("href", objectUrl);
        a.setAttribute("download", "商城订单.xlsx");
        a.click();
        URL.revokeObjectURL(objectUrl);
        this.$message.success("导出成功");
      }).catch(() => {
        this.exportLoading = false;
        this.$message.error("导出失败");
      });
    },
  },
};
</script>

<style>
.table-header-cell-class {
  background: var(--bg-color) !important;
  color: var(--font-color) !important;
  border-right: 0px !important;
}

.ve-table-container {
  height: auto !important;
}

/* 详情弹窗分区标题行:左侧模块名+右侧操作按钮(收货信息模块) */
.detail-section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

/* 分区标题右侧图标按钮:与标题拉开 12px,视觉轻量不抢标题 */
.section-edit-btn {
  margin-left: 12px;
  padding: 0;
  font-size: 16px;
}

/* 修改收货信息弹窗:省/市/区三级下拉同行排布(等宽紧凑) */
.region-selects {
  display: flex;
  gap: 8px;
}

.region-selects .el-select {
  flex: 1;
}
</style>
